<template>
  <div class="pt-page pt-page-current pt-page-portsub pt-page-7 show-overflow upwork-page">
    <router-link class="top-nav" to="/portfolio"><i class="fa fa-arrow-left"></i></router-link>
    <a class="logo" href="/">OM</a>
    <div class="portsub-container text-center">
      <div class="container">
        <div class="col-md-6">
          <div class="upwork-slider">
            <div>
              <img src="../assets/images/upwork-review-large-1.jpg" alt="#">
            </div>
            <div>
              <img src="../assets/images/upwork-review-large-2.jpg" alt="#">
            </div>
            <div>
              <img src="../assets/images/upwork-review-large-3.jpg" alt="#">
            </div>
            <div>
              <img src="../assets/images/upwork-review-1.jpg" alt="#">
            </div>
            <div>
              <img src="../assets/images/upwork-review-2.jpg" alt="#">
            </div>
            <div>
              <img src="../assets/images/upwork-review-6.jpg" alt="#">
            </div>
          </div>
          <div class="mac-screen-slider-dots upwork-dots"></div>
        </div>
        <div class="col-md-6 portsub-right">
          <h1>Reviews of my Work</h1>
          <h2>From Freelance Clients via Upwork</h2>
          <ul>
            <li>I worked as a full time freelance developer for over a year, from late 2015 to early 2017, for a variety of clients across the globe.</li>
            <li>Projects included everything from analytics dashboards, to real time search portals of large datasets, to Wordpress based membership apps.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "../assets/css/font-awesome.min.css";
</style>

<style>
@import "../assets/css/slick.css";
</style>

<style lang="scss">
@import "../assets/scss/portsub.scss";
</style>

<script>
import JQuery from "jquery";
const $ = JQuery;
import "slick-carousel";

export default {
  name: "Upwork",
  mounted: function() {
    $('.upwork-slider').slick({
      autoplay: true,
      autoplaySpeed: 10000,
      arrows: false,
      dots: true,
      fade: true,
      appendDots: $('.mac-screen-slider-dots'),
    });
  }
};
</script>
